import React from 'react';
import { Row, Col } from 'react-bootstrap';

export default function EmergencyResourcesUTSGStaff() {
  return (
    <div>
      <Row>
        <Col xs={10} xsOffset={1}>
          <h2 className="text-center no-bold txt-dkblue">
            Urgent & Emergency Resources
          </h2>
          <p>
            In urgent situations where there’s concerns about anyone's safety, a more
            immediate connection or referral is required even when the person you are
            concerned about is unwilling to access these resources themselves. As soon
            as you can, inform someone who is in a position to act. For situations that
            include harm to self or others, contact the Emergency Situations resources.
            For general, time-sensitive resources, contact one of the Urgent Situations
            resources.
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={10} xsOffset={1}>
          <Col xs={12} sm={6}>
            <div className="situation-grid-container">
              <div className="grid-item-heading">Emergency Situations</div>
              <div className="grid-item">
                <div className="grid-item-info">
                  <strong>Emergency Services</strong>
                  <br />
                  <a href="tel:911">911</a>
                  <br />
                  24/7
                  <br />
                  Various, Ontario
                  <br />
                  <a href="https://crtc.gc.ca/eng/phone/911" rel="noopener noreferrer" target="_blank">
                    crtc.gc.ca/eng/phone/911
                  </a>
                </div>
                For life-threatening emergencies or incidents occurring in the
                moment where you need police, fire, or ambulance. If responding
                on campus also contact Campus Police to ensure prompt service.
              </div>
              <div className="grid-item">
                <div className="grid-item-info">
                  <strong>Campus Police</strong>
                  <br />
                  <a href="tel:416 978 2222">416 978 2222</a>
                  <br />
                  24/7
                  <br />
                  21 Sussex Ave., Suite 100
                  <br />
                  <a href="https://campuspolice.utoronto.ca" rel="noopener noreferrer" target="_blank">
                    campuspolice.utoronto.ca
                  </a>
                </div>
                Provides programs on personal safety, protection of property,
                conflict resolution, maintenance of public order, community
                services and referral, crime prevention and detection.
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div className="situation-grid-container">
              <div className="grid-item-heading">Urgent Situations</div>
              <div className="grid-item">
                <div className="grid-item-info">
                  <strong>Student Crisis Response, Progress & Support</strong>
                  <br />
                  <a href="tel:416 946 7111">416-946-7111</a>
                  <br />
                  Business Hours
                  <br />
                  Various, Campus
                  <br />
                  <a href="https://studentlife.utoronto.ca/service/faculty-support-for-responding-to-distressed-students/" rel="noopener noreferrer" target="_blank">
                    https://studentlife.utoronto.ca/service/faculty-support-for-responding-to-distressed-students/
                  </a>
                </div>
                Resource for staff and faculty who are concerned about a student
                who is overwhelmed or in crisis, exhibiting disturbing
                behaviour, or referencing suicide or violence.
              </div>

              <div className="grid-item">
                <div className="grid-item-info">
                  <strong>U of T Health & Wellness Centre</strong>
                  <br />
                  <a href="tel:416 978 8060">416-978-8030</a>
                  <br />
                  Business Hours
                  <br />
                  214 College St., 2nd Floor
                  <br />
                  <a href="https://www.studentlife.utoronto.ca/hwc" rel="noopener noreferrer" target="_blank">
                    www.studentlife.utoronto.ca/hwc
                  </a>
                </div>
                Confidential mental health and physical health services provided
                by an interdisciplinary team of health professionals.
              </div>
              <div className="grid-item">
                <div className="grid-item-info">
                  <strong>Immediate Supervisor</strong>
                  <br />
                  <span>Name: ___________________</span>
                  <br />
                  <span>Contact: __________________</span>
                </div>
                <span>
                  Whether a referral is made or not - if you are supporting
                  someone as a result of your role as a student leader, staff or
                  faculty member, you should inform your supervisor and/ or the
                  appropriate contact within your unit.
                </span>
              </div>
            </div>
          </Col>
        </Col>
      </Row>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/IARReference/EmergencyResources/EmergencyResourcesUTSGStaff.js